import React from "react";
import {
  Container,
  Navbar,
  NavbarBrand,
  Jumbotron
} from "reactstrap";

function App() {
  return (
    <Container>
      <Navbar color="FFF" light expand="md">
        <NavbarBrand href="/">FlorenceNightingale</NavbarBrand>
      </Navbar>
      <Jumbotron>
        <h1 className="display-3">Medibloc Stake Network Validator</h1>
        <p className="lead">
          panaceavaloper16e4zkqtp7k5h43qrcxwk0spmamq3k286t4dz7t
        </p>
        <hr className="my-2" />
        Coming soon
      </Jumbotron>
      <div>
        Contract : bbbstake@gmail.com
        <br />
        <a href="https://open.kakao.com/o/g3S5KPud">
          Kakao
        </a> | 
        <a href="https://t.me/MediblocNightingaleValidator">
        Telegram
        </a>
      </div>
      <footer>Copyright © 2021 - NightingaleStake - All rights reserved</footer>
    </Container>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js